// Local tokens reproduce the supplied Card2Account v5 mockup without changing the global theme.
export const fontFamily =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif'
export const colors = {
  background: '#F7F8FB',
  ink: '#243247',
  muted: '#738095',
  line: '#E6EAF0',
  lineStrong: '#D9E0E8',
  red: '#D72635',
  redDark: '#BD2130',
  green: '#17806A',
  amber: '#A66E25'
}
export const summaryShadow =
  '0 10px 28px rgba(24,36,58,.05), 0 2px 6px rgba(24,36,58,.025)'

export function getSelectionCounts(simulationResult, selected) {
  const accepted = new Set(
    (simulationResult?.selectedInvoices || []).map((invoice) => invoice.uuid)
  )
  const excluded = new Set(
    (simulationResult?.notSelectedInvoices || []).map((invoice) => invoice.uuid)
  )
  // Selection is the user's input; payable/excluded are projections of the server's decision.
  // Unselected invoices in the simulation must never inflate the warning or the payable badge.
  return {
    selected: selected.length,
    payable: selected.filter((uuid) => accepted.has(uuid)).length,
    excluded: selected.filter((uuid) => excluded.has(uuid)).length
  }
}
